module.exports = __webpack_public_path__ + "img/bronze-donator.85abfe75.png";